'use strict';

/**
 * Collection of scripts related with the store welcome alert.
 */
var storeWelcomeAlert = {};

// Constants
const SELECTOR = {
    INPUT: 'input[name=com-js-welcome-store]'
};

/**
 * Show an alert with an input value if the input exists,
 */
function showAlert() {
    // Constants
    const $INPUT = $(SELECTOR.INPUT);

    if ($INPUT.length) {
        $.alert($INPUT.val(), 'info', true);
    }
}

// Expose functions
storeWelcomeAlert.showAlert = showAlert;

module.exports = storeWelcomeAlert;
